import React from "react";
import { Link } from "react-router-dom";
import styles from "../../styles/Header.module.css";
import { Settings } from "../../../public/icons";
import { BoxPerson } from "../../../public/icons";
import {
  DocumentTypePermissions,
  UserAccount,
  AttributePermissions,
  UserPermissions,
} from "../../interfaces/user";

interface AccountItemRowProps {
  account: UserAccount;
  isCurrentAccount: boolean;
  username: string[];
  switchAccount: (accountId: string) => void;
  setAccountMenu: (open: boolean) => void;
  permissions: UserPermissions;
}

export const AccountSwitcherItem: React.FC<AccountItemRowProps> = ({
  account,
  permissions,
  isCurrentAccount,
  username,
  switchAccount,
  setAccountMenu,
}) => {
  const [isHovered, setIsHovered] = React.useState(false);

  const SETTINGS_PERMISSIONS: (
    | keyof AttributePermissions
    | keyof DocumentTypePermissions
  )[] = [
    "attribute.create",
    "attribute.delete",
    "attribute.update",
    "document-type.create",
    "document-type.update",
  ];

  const checkAccountPermissionsOr = (
    permissions: UserPermissions,
    permissionList: (
      | keyof AttributePermissions
      | keyof DocumentTypePermissions
    )[],
  ): boolean => {
    if (!permissions) return false;

    return permissionList.some((perm) => !!permissions[perm]);
  };

  const hasPermissions = checkAccountPermissionsOr(
    permissions,
    SETTINGS_PERMISSIONS,
  );

  const getBackgroundColor = () => {
    if (isCurrentAccount) return "var(--disabled-bg)";
    if (isHovered) return "var(--disabled-bg)";
    return "transparent";
  };

  return (
    <div
      onMouseEnter={() => !isCurrentAccount && setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        display: "flex",
        alignItems: "center",
        marginTop: "4px",
        backgroundColor: getBackgroundColor(),
        transition: "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1)",
        cursor: isCurrentAccount ? "default" : "pointer",
      }}
    >
      <button
        className={styles.account_btn}
        type="button"
        onClick={() => switchAccount(account.id)}
        disabled={isCurrentAccount}
        style={{ flex: 1 }}
      >
        <div>
          {account.company.code === "" ? (
            <div style={{ display: "flex", gap: "15px", alignItems: "center" }}>
              <div className={styles.avatar}>
                {username
                  .map((el) => el.charAt(0).toUpperCase())
                  .join("")
                  .substring(0, 2)}
              </div>
              <div>
                <p style={{ color: "var(--disabled-c)", fontSize: "10px" }}>
                  Фізична особа:
                </p>

                <p>{username.join(" ")}</p>
                <p style={{ fontSize: "11px", fontWeight: 700 }}>
                  {account.code}
                </p>
                <p>{(account as any).email}</p>
              </div>
            </div>
          ) : (
            <div style={{ display: "flex", gap: "15px", alignItems: "center" }}>
              <div className={styles.avatarCompany}>
                <BoxPerson />
              </div>
              <div>
                <p style={{ color: "var(--disabled-c)", fontSize: "10px" }}>
                  {account.title}
                </p>
                <p>{username.join(" ")}</p>
                <p>{account.company.title}</p>
                <p style={{ fontSize: "11px", fontWeight: 700 }}>
                  {account.company.code}
                </p>
              </div>
            </div>
          )}
        </div>
      </button>

      {hasPermissions && isCurrentAccount ? (
        <Link
          to="/settings/attribute"
          style={{ flexShrink: 0, paddingRight: 20, paddingLeft: 8 }}
          onClick={() => setAccountMenu(false)}
          aria-disabled={isCurrentAccount && !hasPermissions}
        >
          <Settings color="var(--blue)" />
        </Link>
      ) : (
        <div style={{ flexShrink: 0, paddingRight: 20, paddingLeft: 8 }}>
          <Settings color="transparent" />
        </div>
      )}
    </div>
  );
};
